module.exports = __webpack_public_path__ + "img/slide2.9de32b2f.jpg";